var map = {
	"./close.svg": "7710",
	"./error.svg": "b1b9",
	"./map.svg": "a13f",
	"./mapBack.svg": "79a9",
	"./paper.svg": "dd45",
	"./play.svg": "fb4f",
	"./project.svg": "69e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";